










































import { Component, Prop, Vue } from 'vue-property-decorator'
import CommonModal from '@/components/common/CommonModal.vue'
import CommonButton from '@/components/common/CommonButton.vue'
import CommonAddButton from '@/components/common/CommonAddButton.vue'
import { mapGetters } from 'vuex'

export interface Followers {
  id: number
  label: string
  price: string
  selected: boolean
}

@Component({
  components: { CommonAddButton, CommonButton, CommonModal },
  computed: {
    ...mapGetters('builder', {  promotionalPage: 'getPromotionalPage' })
  }
})
export default class BuilderPrivateChatSettingsModal extends Vue {

  promotionalPage!: any

  @Prop({ required: true, type: Number }) value!: number

  onSelect(id: number): void {
    this.$emit(
      'input',
      this.promotionalPage?.id
    )
    this.$emit('close')
  }

}
